<template>
    <v-container fluid style="max-width:1700px">
        <v-row>
            <v-col cols="12" class="d-flex flex-column">
                <v-card>
                    <div class="chart-title">
                        {{ $t('ExecutiveAnalytics')}}
                    </div>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <v-autocomplete hide-details dense outlined :items="surveys" v-model="selectedSurveys" item-value="id" item-text="nameAr" :label="$t('Surveys')">
                                    <template v-slot:item="{ item }">
                                        {{ item.id }} -  {{ isArabicLanguage ? item.nameAr : item.nameEn }}
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="6">
                                <v-autocomplete searchable dense hide-details
                                                multiple
                                                clearable
                                                outlined
                                                v-model="selectedMunicipalityItems"
                                                :items="municipalityItems"
                                                item-value="id"
                                                item-text="name"
                                                :label="$t('sharedWithMunicipality')">
                                    <template v-slot:prepend-item>
                                        <v-list-item @click="selectAllItems">
                                            <v-list-item-content>{{ $t('SelectAll') }}</v-list-item-content>
                                        </v-list-item>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-list-item-content>
                                            <h4>{{ item.name }}</h4>
                                        </v-list-item-content>
                                    </template>
                                    <template v-slot:selection="{ item }">
                                        <v-chip small :key="item.id" close @click:close="removeItem(item.id)">
                                            {{ item.name }}
                                        </v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col md="6" cols="12">
                                <!-- Filter by Year -->
                                <v-menu v-model="yearMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field hide-details v-model="selectedYear" outlined clearable dense
                                                      :label="$t('Year')"
                                                      readonly
                                                      v-bind="attrs"
                                                      v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="yearPicker" :max="maxDate"
                                                   type="year" @click:year="selectYear($event)"></v-date-picker>
                                </v-menu>

                            </v-col>
                            <v-col md="6" cols="12">
                                <!-- Filter by Quarter (using Calendar) -->
                                <v-select hide-details v-model="selectedQuarter" clearable outlined dense
                                          :items="quarters"
                                          :label="$t('Quarter')"></v-select>
                            </v-col>
                            <v-col md="6" cols="12">
                                <v-select v-model="selectedIcon"
                                          :items="icons"
                                          item-value="id"
                                          :label="$t('QuestionIconType')"
                                          :item-text="language == 'ar' ? 'iconTypeNameAr' : 'iconTypeNameEn'"
                                          outlined dense clearable>
                                    <!-- Custom item rendering -->

                                </v-select>
                            </v-col>

                        </v-row>
                        <v-row>
                            <v-col sm="2" md="2" cols="12" v-if="selectedAvgTime">
                                <v-text-field dense outlined v-model="selectedAvgTime" :label="$t('SurveyAvgTime')" :disabled="true" />
                            </v-col>
                        </v-row>
                        <v-row v-for="q in filterquestions" :key="q.id">
                            <v-col>
                                <v-select dense v-model="q.selectedValue" clearable outlined :items="q.options" :label="q.title" item-text="name" item-value="id"></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-btn color="secondary" class="my-3 ms-3 float-end" @click="clear()" :loading="loading">
                                    {{$t('Clear') }}
                                </v-btn>
                                <v-btn color="primary" class="my-3 float-end" @click="loadDemographics" :loading="loading">
                                    {{$t('Apply') }}
                                </v-btn>

                            </v-col>
                        </v-row>
                        <v-card class="elevation-0" v-if="result.length>0">
                            <div class="chart-title">{{$t('Municipalities')}}</div>
                            <v-card-text>
                                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loading"></v-skeleton-loader>
                                <v-card-text v-if="!loading">
                                    <MunicipalitiesChart v-if="result.length>0" v-model="amanatData" @selectMunicipality="selectMunicipality" />
                                </v-card-text>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col v-for="q in filteredQuestions" :key="q.id" cols="12" :md="columSize(q.resultTypeId)" class="d-flex flex-column">

                <template v-if="q.resultTypeId === ResultTypes.NPS">
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingnpsresults"></v-skeleton-loader>
                    <NPSChart :iconName="questionIconName(q.iconTypeId)" :q="q" @filterQuestionOption="filterQuestionOption" :icon="questionIcon(q.iconTypeId)" v-if="!loadingnpsresults" v-model="q.npsresults" :scores="q.npsscale" :title="language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn" />
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.CSAT51">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsatisfactionAllRecords"></v-skeleton-loader>
                    <SatisfactionFiveLevels :q="q" @filterQuestionOption="filterQuestionOption" v-if="!loadingsatisfactionAllRecords" v-model="q.satisfactionTable" />
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.TripleSatisfaction">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingtripleSatisfactionTable"></v-skeleton-loader>
                    <v-card color="#efeded" style="height:100%" v-if="!loadingtripleSatisfactionTable && q.tripleSatisfactionTable">
                        <v-card-text>
                            <SatisfactionThreeLevels v-model="q.tripleSatisfactionTable" :q="q" @filterQuestionOption="filterQuestionOption" />
                        </v-card-text>
                    </v-card>
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.SignedQuestion">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsignedquestionanswers"></v-skeleton-loader>
                    <SignedQuestionChart :q="q" @filterQuestionOption="filterQuestionOption" v-model="q.signedquestionanswers" v-if="!loadingsignedquestionanswers && q.signedquestionanswers" />
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.CSAT5Amanat && (q.csatfivetwoTable && q.csatfivetwoTable.filter(x => x.count > 0).length > 0 || loadingcsatfivetwoTable)">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingcsatfivetwoTable"></v-skeleton-loader>
                    <SatisfactionFiveLevels v-if="!loadingcsatfivetwoTable" v-model="q.csatfivetwoTable" :q="q" @filterQuestionOption="filterQuestionOption" />
                </template>


                <template v-else-if="q.resultTypeId === ResultTypes.PreCommunication">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingprecommunicationresults"></v-skeleton-loader>
                    <PreCommunicationChart :q="q" @filterQuestionOption="filterQuestionOption" v-model="q.precommunicationresults" v-if="!loadingprecommunicationresults && q.precommunicationresults" />
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.Reservation">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingreservationresults"></v-skeleton-loader>
                    <ReservationChart :q="q" @filterQuestionOption="filterQuestionOption" v-model="q.reservationresults" v-if="!loadingreservationresults && q.reservationresults" />
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.Filter">
                    <div class="chart-title d-flex justify-space-between align-center mt-0">
                        {{ language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn }}
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(q.iconTypeId)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(q.iconTypeId) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsakaniproducts"></v-skeleton-loader>
                    <SakaniProductsChart :q="q" v-model="q.sakaniproducts" v-if="!loadingsakaniproducts && q.sakaniproducts" @filterQuestionOption="filterQuestionOption" />
                </template>
                <template v-else-if="q.resultTypeId === ResultTypes.Regions">
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingregionsTablePerQuestions"></v-skeleton-loader>
                    <RegionsChart v-if="!loadingregionsTablePerQuestions && q.regionsTablePerQuestions && q.regionsTablePerQuestions.length>0" v-model="q.regionsTablePerQuestions" :q="q" @filterQuestionOption="filterQuestionOption" />
                    <!--<MunicipalitiesPerQuestionChart v-if="!loadingregionsTablePerQuestions && q.amanatTablePerQuestions && q.amanatTablePerQuestions.length>0" v-model="q.amanatTablePerQuestions" />-->
                </template>
            </v-col>

            <!--<v-col cols="12" v-if="resultregion.filter(x=>x.count>0).length>0 || loadingregion" style="height:100%">
        <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingregion"></v-skeleton-loader>
        <RegionsChart v-if="!loadingregion" v-model="resultregion" />

    </v-col>-->

            <v-col cols="12" v-if="awarenessTablePerQuestions.length>0 || loadingawarenessTablePerQuestions" class="d-flex flex-column">

                <div class="chart-title d-flex justify-space-between align-center mt-0">
                    {{ $t('AwarenessLevel') }}

                </div>
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingawarenessTablePerQuestions"></v-skeleton-loader>
                <v-card style="background-color: #efeded; height: 100%">
                    <v-card-text>
                        <AwarenessChart v-if="!loadingawarenessTablePerQuestions" v-model="awarenessTablePerQuestions" />
                    </v-card-text>
                </v-card>

            </v-col>
            <v-col v-for="q in filteredQuestions.filter(x=>x.resultTypeId == ResultTypes.CSAT5Amanat)" :key="q.id" cols="12" class="d-flex flex-column">
                <template v-if="q.resultTypeId === ResultTypes.CSAT5Amanat && (q.satisfactionData && q.satisfactionData.filter(z => z > 0).length > 0 || loadingsatisfactionData)">

                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsatisfactionData"></v-skeleton-loader>
                    <v-card class="elevation-5 mt-4 rounded-lg" v-if="!loadingsatisfactionData" style="height:100%">
                        <SatisfactionChart :satisfactionLabels="q.satisfactionLabels" :satisfactionLogos="q.satisfactionLogos" :satisfactionData="q.satisfactionData" :title="language === 'ar' ? q.analyticsNameAr : q.analyticsNameEn" :q="q" @filterQuestionOption="filterQuestionOption" />
                    </v-card>
                </template>
            </v-col>
            <v-col cols="12" class="d-flex flex-column">
                <template v-if="loadingsatisfactionData || (satisfactionData && satisfactionData.filter(z => z > 0).length > 0)">

                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsatisfactionData"></v-skeleton-loader>
                    <v-card class="elevation-5 mt-4 rounded-lg" v-if="!loadingsatisfactionData" style="height:100%">
                        <SatisfactionChart :satisfactionLabels="satisfactionLabels" :satisfactionLogos="satisfactionLogos" :satisfactionData="satisfactionData" title="" />
                    </v-card>
                </template>
            </v-col>
            
            <v-col cols="12" v-if="satisfactionTablePerQuestions.length>0 || loadingsatisfactionTablePerQuestions" class="d-flex flex-column">

                <div class="chart-title d-flex justify-space-between align-center mt-0">
                    {{ $t('SatisfactionPerQuestion') }}
                    <span class="icon">
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(2)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(2) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </span>
                </div>
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsatisfactionTablePerQuestions"></v-skeleton-loader>
                <SatisfactionPerQuestionChart v-if="!loadingsatisfactionTablePerQuestions" v-model="satisfactionTablePerQuestions" :quarters="quarters" @selectSatisfactionPerQuestionYear="selectSatisfactionPerQuestionYear" @selectSatisfactionPerQuestionQuarter="selectSatisfactionPerQuestionQuarter" />
            </v-col>
            <v-col cols="12" v-if="satisfactionTablePerQuestions2.length>0 || loadingsatisfactionTablePerQuestions2" class="d-flex flex-column">

                <div class="chart-title d-flex justify-space-between align-center mt-0">
                    {{ $t('SatisfactionPerQuestion') }}
                    <span class="icon">
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(2)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(2) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </span>
                </div>
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsatisfactionTablePerQuestions"></v-skeleton-loader>
                <SatisfactionPerQuestionChart v-if="!loadingsatisfactionTablePerQuestions2" v-model="satisfactionTablePerQuestions2" :quarters="quarters" @selectSatisfactionPerQuestionYear="selectSatisfactionPerQuestionYear2" @selectSatisfactionPerQuestionQuarter="selectSatisfactionPerQuestionQuarter2" />
            </v-col>
            <v-col cols="12" v-if="satisfactionTablePerQuestions3.length>0 || loadingsatisfactionTablePerQuestions3" class="d-flex flex-column">

                <div class="chart-title d-flex justify-space-between align-center mt-0">
                    {{ $t('SatisfactionPerQuestion') }}
                    <span class="icon">
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(2)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(2) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </span>
                </div>
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsatisfactionTablePerQuestions3"></v-skeleton-loader>
                <SatisfactionPerQuestionChart v-if="!loadingsatisfactionTablePerQuestions3" v-model="satisfactionTablePerQuestions3" />
            </v-col>
            
            <v-col cols="12" v-if="(satisfactionQuartersPercentages.length>0 && satisfactionQuartersPercentages.filter(z=>z>0).length>0) || loadingsatisfactionQuarters" class="d-flex flex-column">
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsatisfactionQuarters"></v-skeleton-loader>
                <SatisfactionQuartersChart :satisfactionQuartersLabels="satisfactionQuartersLabels" :availableYears="availableYears" :satisfactionQuartersPercentages="satisfactionQuartersPercentages" v-if="!loadingsatisfactionQuarters" />
            </v-col>
            
            <v-col cols="12" v-if="filteredDemographicsQuestions.length>0">
                <div class="chart-title d-flex justify-space-between align-center mt-0">
                    {{ $t('Demographics') }}

                </div>
                <v-card>
                    <v-card-text>
                        <v-row v-for="(row, rowIndex) in groupedQuestions" :key="'row-' + rowIndex">
                            <v-col v-for="q in row"
                                   :key="q.id"
                                   cols="rowIndex === 0 && groupedQuestions.length > 1 && groupedQuestions[0].length === 3 ? 'auto' : 6"
                                   d-flex
                                   class="d-flex flex-column">
                                <template v-if="q.resultTypeId === ResultTypes.Gender">
                                    <div class="chart-title mt-0">{{ language === 'ar' ? q.questionAr : q.questionEn }}</div>
                                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadinggenders"></v-skeleton-loader>
                                    <v-card color="#efeded" v-if="!loadinggenders" style="height: 100%">
                                        <v-card-text>
                                            <GenderChart v-model="q.genders" v-if="!loadinggenders && q.genders" :q="q" @filterQuestionOption="filterQuestionOption" />
                                        </v-card-text>
                                    </v-card>
                                </template>

                                <template v-else-if="q.resultTypeId === ResultTypes.Nationality">
                                    <div class="chart-title mt-0">{{ language === 'ar' ? q.questionAr : q.questionEn }}</div>
                                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingnationalities"></v-skeleton-loader>
                                    <NationalityChart v-model="q.nationalities" v-if="!loadingnationalities && q.nationalities" :q="q" @filterQuestionOption="filterQuestionOption"></NationalityChart>
                                </template>

                                <template v-else-if="q.resultTypeId === ResultTypes.Publication">
                                    <div class="chart-title mt-0">{{ language === 'ar' ? q.questionAr : q.questionEn }}</div>
                                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingpublications"></v-skeleton-loader>
                                    <PublicationChart v-model="q.publications" v-if="!loadingpublications && q.publications" :q="q" @filterQuestionOption="filterQuestionOption" />
                                </template>

                                <template v-else-if="q.resultTypeId === ResultTypes.AgeGroup">
                                    <div class="chart-title mt-0">{{ language === 'ar' ? q.questionAr : q.questionEn }}</div>
                                    <v-skeleton-loader type="list-item-avatar, divider, card-heading, image" v-if="loadingageGroup"></v-skeleton-loader>
                                    <AgeGroupChart v-model="q.ageGroup" v-if="!loadingageGroup && q.ageGroup" :q="q" @filterQuestionOption="filterQuestionOption" />
                                </template>

                                <template v-else-if="q.resultTypeId === ResultTypes.EducationalLevel">
                                    
                                            <div class="chart-title mt-0">
                                                {{ language === 'ar' ? q.questionAr : q.questionEn }}
                                            </div>
                                        <v-skeleton-loader type="list-item-avatar, divider, card-heading, image" v-if="loadingeducationalLevel"></v-skeleton-loader>
                                        <EducationLevelChart @filterQuestionOption="filterQuestionOption" :q="q" v-model="q.educationalLevel" v-if="!loadingeducationalLevel && q.educationalLevel" />
                                    
                                </template>

                                <template v-else-if="q.resultTypeId === ResultTypes.Profession">
                                    <div class="chart-title mt-0">{{ language === 'ar' ? q.questionAr : q.questionEn }}</div>
                                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingprofessions"></v-skeleton-loader>
                                    <ProfessionsChart v-model="q.professions" v-if="!loadingprofessions && q.professions" :q="q" @filterQuestionOption="filterQuestionOption" />
                                </template>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import StructuresService from '@/services/StructuresService'
    import SurveyService from '@/services/SurveyService'
    import { mapGetters } from 'vuex'
    import { AnalyticsTypes, ResultTypes, SurveyQuestionIcon } from '@/helpers/constants/enumerations.js'
    import SatisfactionChart from '@/components/controls/SatisfactionChart.vue'
    import GenderChart from '@/components/charts/GenderForExecutives.vue'
    import AgeGroupChart from '@/components/charts/AgeGroupForExecutives.vue'
    import SignedQuestionChart from '@/components/charts/SignedQuestionForExecutives.vue'
    import SatisfactionFiveLevels from '@/components/charts/SatisfactionFiveLevelsForExecutives.vue'
    import SatisfactionThreeLevels from '@/components/charts/SatisfactionThreeLevelsForExecutives.vue'
    import MunicipalitiesChart from '@/components/charts/MunicipalitiesBar.vue'
    //import MunicipalitiesPerQuestionChart from '@/components/charts/MunicipalitiesPerQuestionBar.vue'
    import AwarenessChart from '@/components/charts/AwarenessBar.vue'
    import NPSChart from '@/components/charts/NPSChart.vue'
    import EducationLevelChart from '@/components/charts/EducationLevelForExecutives.vue'
    import ProfessionsChart from '@/components/charts/ProfessionsForExecutives.vue'
    import SatisfactionPerQuestionChart from '@/components/charts/SatisfactionPerQuestionForExecutives.vue'
    import SatisfactionQuartersChart from '@/components/controls/SatisfactionQuartersChart.vue'
    import PreCommunicationChart from '@/components/charts/PreCommunicationForExecutives.vue'
    import ReservationChart from '@/components/charts/ReservationForExecutives.vue'
    import SakaniProductsChart from '@/components/charts/SakaniProductsForExecutives.vue'
    import NationalityChart from '@/components/charts/Nationality.vue'
    import RegionsChart from '@/components/charts/RegionsBar.vue'
    export default {
        components: {
            GenderChart, SignedQuestionChart, SatisfactionFiveLevels, MunicipalitiesChart, SatisfactionChart, /*MunicipalitiesPerQuestionChart,*/ AwarenessChart, NPSChart, EducationLevelChart, ProfessionsChart, SatisfactionPerQuestionChart, SatisfactionQuartersChart, PreCommunicationChart, SakaniProductsChart, AgeGroupChart, NationalityChart, SatisfactionThreeLevels, RegionsChart, ReservationChart
        },
        data() {
            return {
                selectedMunicipalityItems: [],
                municipalityItems: [],
                ResultTypes: ResultTypes,
                SurveyQuestionIcon: SurveyQuestionIcon,
                questions: [],
                amanatData:[],
                surveys: [],
                selectedSurveys: 0,
                selectedAvgTime:null,
                result: [],
                resultregion: [],
                genders: [],
                gendertitle: '',
                professions: [],
                professionstitle: '',
                maxStars: 5,
                nationalities: [],
                nationalitytitle: '',
                ageGroup: [],
                educationalLevel: [],
                educationalLeveltitle: '',
                publications: [],
                publicationstitle: '',
                loading: false,
                loadingregion: false,
                satisfactionLabels: [],
                satisfactiontitle: '',
                npsresults: [],
                npstitle: '',
                npsscale: [],
                satisfactionLogos: [],
                satisfactionData: [],
                satisfactionTable: [],
                satisfactionTableTitle: '',
                csatfivetwoTable: [],
                csatfivetwoTableTitle: '',
                satisfactionTablePerQuestions: [],
                satisfactionTablePerQuestions2: [],
                satisfactionTablePerQuestions3: [],
                tripleSatisfactionTable: [],
                tripleSatisfactionTableTitle: '',
                signedquestionanswers: [],
                signedquestionName: '',
                precommunicationresults: [],
                precommunicationtitle: '',
                endorsmentResults: [],
                endorsmentTitle: '',
                comreasons: [],
                comreasonstitle: '',
                sakaniproducts: [],
                sakaniproductstitle: '',
                loadinggenders: false,
                loadingsignedquestionanswers: false,
                loadingprofessions: false,
                loadingnationalities: false,
                loadingageGroup: false,
                loadingeducationalLevel: false,
                loadingpublications: false,
                loadingsatisfactionData: false,
                loadingsatisfactionData4: false,
                loadingsatisfactionAllRecords: false,
                loadingsatisfactionQuarters: false,
                loadingsatisfactionQuarters4: false,
                loadingcomreasons: false,
                loadingprecommunicationresults: false,
                loadingreservationresults: false,
                loadingsatisfactionTablePerQuestions: false,
                loadingsatisfactionTablePerQuestions2: false,
                loadingsatisfactionTablePerQuestions3: false,
                awarenessTablePerQuestions: [],
                loadingawarenessTablePerQuestions:false,
                loadingregionsTablePerQuestions:false,
                loadingtripleSatisfactionTable: false,
                filterquestions: [],
                loadingsakaniproducts: false,
                loadingnpsresults: false,
                loadingendorsmentResults: false,
                loadingcsatfivetwoTable: false,
                agegrouptitle: '',
                data: [
                    { category: 'Task A', value: 10 },
                    { category: 'Task B', value: 35 },
                    { category: 'Task C', value: 65 },
                    { category: 'Task D', value: 90 },
                    { category: 'Task D', value: 3 },
                    { category: 'Task D', value: 90 },
                    { category: 'Task D', value: 13 },
                    { category: 'Task D', value: 5 },
                    { category: 'Task D', value: 90 },
                    { category: 'Task D', value: 25 },
                    { category: 'Task D', value: 75 },
                    { category: 'Task E', value: 42 }
                ],
                yearMenu: false,
                quarterMenu: false,
                selectedYear: null,
                selectedQuarter: null,
                yearPicker: null,
                maxDate: new Date().toISOString().split('T')[0],
                quarters: [{ value: 'q1', text: this.$t('QuarterOne') }, { value: 'q2', text: this.$t('QuarterTwo') }, { value: 'q3', text: this.$t('QuarterThree') }, { value: 'q4', text: this.$t('QuarterFour') }],
                satisfactionQuartersLabels: [],
                satisfactionQuartersPercentages: [],
                availableYears: [],
                satisfactionQuartersLabels4: [],
                satisfactionQuartersPercentages4: [],
                availableYears4: [],
                selectedSignedQuestionYear: null,
                selectedSignedQuestionQuarter: null,
                selectedGenderYear: null,
                selectedGenderQuarter: null,
                selectedNPSYear: null,
                selectedNPSQuarter: null,
                selectedCSATFiveYear: null,
                selectedCSATFiveQuarter: null,
                selectedEducationLevelYear: null,
                selectedEducationLevelQuarter: null,
                selectedProfessionYear: null,
                selectedProfessionQuarter: null,
                selectedPrecommunicationYear: null,
                selectedPrecommunicationQuarter: null,
                selectedSakaniProductsYear: null,
                selectedSakaniProductsQuarter: null,
                selectedSatisfactionPerQuestionYear: null,
                selectedSatisfactionPerQuestionQuarter: null,
                icons: [],
                selectedIcon: null,
            }
        },
        computed: {
            ...mapGetters('user', ['loggedInUser', 'language']),
            isArabicLanguage() {
                return this.language == 'ar'
            },
            
            groupedQuestions() {
                let items = this.filteredDemographicsQuestions.filter(q =>
                    [ResultTypes.Publication, ResultTypes.Gender, ResultTypes.Nationality, ResultTypes.AgeGroup, ResultTypes.EducationalLevel, ResultTypes.Profession].includes(q.resultTypeId)
                )

                let result = []

                if (items.length >= 5) {
                    // If 6 or more, first row has 3, second row has 2, rest have 2 per row
                    result.push(items.slice(0, 3)) // First row: 3 items
                    result.push(items.slice(3, 5)) // Second row: 2 items
                    for (let i = 5; i < items.length; i += 2) {
                        result.push(items.slice(i, i + 2)) // Remaining items in pairs of 2
                    }
                } else {
                    // If less than 6, ensure every row has exactly 2 items
                    for (let i = 0; i < items.length; i += 2) {
                        result.push(items.slice(i, i + 2))
                    }
                }

                return result
            },
            columSize() {
                return (resultTypeId) => {
                    var col = '6'
                    switch (resultTypeId) {
                        case this.ResultTypes.EducationalLevel:
                        case this.ResultTypes.AgeGroup:
                        case this.ResultTypes.Gender:
                        case this.ResultTypes.Filter:
                        case this.ResultTypes.Nationality:
                        case this.ResultTypes.Publication:
                        case this.ResultTypes.Profession:
                        case this.ResultTypes.SignedQuestion:
                        case this.ResultTypes.CommunicationReason:
                        case this.ResultTypes.PreCommunication:
                        case this.ResultTypes.TripleSatisfaction:
                        case this.ResultTypes.Endorsment:
                        case this.ResultTypes.CSAT51:
                        case this.ResultTypes.NPS:
                        case this.ResultTypes.CSAT5Amanat:
                            col = '6'
                            break
                        case this.ResultTypes.Regions:
                            col = '12'
                            break
                        default:
                            col = '6'
                            break
                    }
                    return col
                }
            },

            questionIconName() {
                return (id) => {
                    var result = this.icons.filter(x => x.id == id)[0]

                    return result ? (this.language == 'ar' ? result.iconTypeNameAr : result.iconTypeNameEn) : ''
                }
            },
            questionIcon() {
                return (id) => {
                    var result = this.icons.filter(x => x.id == id)[0]

                    return result ? result.icon : ''
                }
            },
            filteredQuestions() {
                // Filter questions to only include those with the relevant resultTypeId
                return this.questions ? this.questions.filter(
                    (q) =>
                        //(q.resultTypeId === this.ResultTypes.EducationalLevel && ((q.educationalLevel && q.educationalLevel.filter(x => x.count > 0).length > 0) || this.loadingeducationalLevel)) ||
                        //(q.resultTypeId === this.ResultTypes.AgeGroup && (this.ageGroup.filter(x => x.count > 0).length > 0 || this.loadingageGroup)) ||
                        //(q.resultTypeId === this.ResultTypes.Gender && ((q.genders && q.genders.filter(x => x.count > 0).length > 0) || this.loadinggenders)) ||
                        (q.resultTypeId == this.ResultTypes.Filter && ((q.sakaniproducts && q.sakaniproducts.filter(x => x.count > 0).length > 0) || this.loadingsakaniproducts)) ||
                        //(q.resultTypeId === this.ResultTypes.Nationality && (this.nationalities.filter(x => x.count > 0).length > 0 || this.loadingnationalities)) ||
                        //(q.resultTypeId === this.ResultTypes.Publication && (this.publications.length > 0 || this.loadingpublications)) ||
                        (q.resultTypeId === this.ResultTypes.SignedQuestion && ((q.signedquestionanswers && q.signedquestionanswers.filter(x => x.count > 0).length > 0) || this.loadingsignedquestionanswers)) ||
                        //(q.resultTypeId === this.ResultTypes.CommunicationReason && (this.comreasons.filter(x => x.count > 0).length > 0 || this.loadingcomreasons)) ||
                        (q.resultTypeId === this.ResultTypes.PreCommunication && ((q.precommunicationresults && q.precommunicationresults.filter(x => x.count > 0).length > 0) || this.loadingprecommunicationresults)) ||
                        (q.resultTypeId === this.ResultTypes.Reservation && ((q.reservationresults && q.reservationresults.filter(x => x.count > 0).length > 0) || this.loadingreservationresults)) ||
                        (q.resultTypeId === this.ResultTypes.TripleSatisfaction && ((q.tripleSatisfactionTable && q.tripleSatisfactionTable.length > 0 && q.tripleSatisfactionTable.filter(x => x.count > 0 && x.percentage > 0).length > 0) || this.loadingtripleSatisfactionTable)) ||
                        (q.resultTypeId === this.ResultTypes.NPS && ((q.npsresults && q.npsresults.length > 0) || this.loadingnpsresults)) ||
                        //(q.resultTypeId === this.ResultTypes.Endorsment && ((this.endorsmentResults.filter(x => x.count > 0).length > 0) || this.loadingendorsmentResults)) ||
                        (q.resultTypeId === this.ResultTypes.CSAT51 && ((q.satisfactionTable && q.satisfactionTable.length>0 && q.satisfactionTable.filter(x => x.count > 0).length > 0) || this.loadingsatisfactionAllRecords)) ||
                        (q.resultTypeId === this.ResultTypes.Regions && ((q.regionsTablePerQuestions && q.regionsTablePerQuestions.length > 0 && q.regionsTablePerQuestions.filter(x => x.count > 0).length > 0) || this.loadingregionsTablePerQuestions)) ||
                        (q.resultTypeId === this.ResultTypes.Regions && ((q.amanatTablePerQuestions && q.amanatTablePerQuestions.length > 0 && q.amanatTablePerQuestions.filter(x => x.count > 0).length > 0) || this.loadingregionsTablePerQuestions)) ||
                        (q.resultTypeId === this.ResultTypes.CSAT5Amanat && ((q.satisfactionData && q.satisfactionData.filter(z => z > 0).length > 0 || this.loadingsatisfactionData) || (q.csatfivetwoTable && q.csatfivetwoTable.filter(x => x.count > 0).length > 0 || this.loadingcsatfivetwoTable)))
                ) : []
            },
            filteredDemographicsQuestions() {
                // Filter questions to only include those with the relevant resultTypeId
                return this.questions ? this.questions.filter(
                    (q) =>
                        (q.resultTypeId === this.ResultTypes.EducationalLevel && ((q.educationalLevel && q.educationalLevel.filter(x => x.count > 0).length > 0) || this.loadingeducationalLevel)) ||
                        (q.resultTypeId === this.ResultTypes.AgeGroup && (q.ageGroup && q.ageGroup.filter(x => x.count > 0).length > 0 || this.loadingageGroup)) ||
                        (q.resultTypeId === this.ResultTypes.Gender && ((q.genders && q.genders.filter(x => x.count > 0).length > 0) || this.loadinggenders)) ||
                        (q.resultTypeId === this.ResultTypes.Nationality && (q.nationalities && q.nationalities.filter(x => x.count > 0).length > 0 || this.loadingnationalities))||
                        (q.resultTypeId === this.ResultTypes.Profession && ((q.professions && q.professions.filter(x => x.count > 0).length > 0) || this.loadingprofessions))

                        
                ) : []
            },
        },
        watch: {
            selectedSurveys: {
                handler: function (val, oldVal) {
                    var newsurvey = this.surveys.filter(x => x.id == val)
                    if(newsurvey && newsurvey.length>0)
                        this.selectedAvgTime = newsurvey[0].avgTime
                    else
                        this.selectedAvgTime = null
                },
                deep: true
            }
        },
        created() {
            this.listMunicipalities()
            this.listSurveys()
            //this.listFilterQuestions()
            this.listQuestionIcons()
            // this.loadDemographics()
        },

        methods: {
            filterQuestionOption(item, q, options) {
                const questionIndex = this.filterquestions.findIndex(x => x.id === q.id)

                if (questionIndex !== -1) {
                    // Remove the question if it exists
                    this.filterquestions.splice(questionIndex, 1)
                } 
                    // Add the question if it does not exist
                    const filterq = {
                        id: q.id,
                        reference: q.reference,
                        title: q.questionAr,
                        note: q.noteAr,
                        questionTypeId: q.questionTypeId,
                        order: q.orderBy,
                        selectedValue: item.id,
                        options: options
                    }
                this.filterquestions.push(filterq)
                    this.loadDemographics()
                
            },
            selectSignedQuestionQuarter(quarter) {
                if (!quarter) {
                    this.loadingsignedquestionanswers = true
                }
                this.selectedSignedQuestionQuarter = quarter
                this.listSignedQuestionAnswers(this.selectedSurveys, this.selectedMunicipalityItems)

            },
            selectSignedQuestionYear(year) { 
                if (!year) {
                    this.loadingsignedquestionanswers = true
                }
                this.selectedSignedQuestionYear = year
                this.listSignedQuestionAnswers(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectGenderQuarter(quarter) {
                if (!quarter) {
                    this.loadinggenders = true
                }
                this.selectedGenderQuarter = quarter
                this.listGenders(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectGenderYear(year) {
                if (!year) {
                    this.loadinggenders = true
                }
                this.selectedGenderYear = year
                this.listGenders(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectNPSQuarter(quarter) {
                if (!quarter) {
                    this.loadingnpsresults = true
                }
                this.selectedNPSQuarter = quarter
                this.listNPSResults(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectNPSYear(year) {
                if (!year) {
                    this.loadingnpsresults = true
                }
                    this.selectedNPSYear = year
                    this.listNPSResults(this.selectedSurveys, this.selectedMunicipalityItems)
                
            },
            selectCSATFiveQuarter(quarter) {
                if (!quarter) {
                    this.loadingsatisfactionAllRecords = true
                }
                this.selectedCSATFiveQuarter = quarter
                this.listSakaniSatisfactionAllRecordsAsync(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectCSATFiveYear(year) {
                if (!year) {
                    this.loadingsatisfactionAllRecords = true
                }
                this.selectedCSATFiveYear = year
                this.listSakaniSatisfactionAllRecordsAsync(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectEducationLevelQuarter(quarter) {
                if (!quarter) {
                    this.loadingeducationalLevel = true
                }
                this.selectedEducationLevelQuarter = quarter
                this.listEucationalLevels(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectEducationLevelYear(year) {
                if (!year) {
                    this.loadingeducationalLevel = true
                }
                this.selectedEducationLevelYear = year
                this.listEucationalLevels(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectProfessionQuarter(quarter) {
                if (!quarter) {
                    this.loadingprofessions = true
                }
                this.selectedProfessionQuarter = quarter
                this.listProfessions(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectProfessionYear(year) {
                if (!year) {
                    this.loadingprofessions = true
                }
                this.selectedProfessionYear = year
                this.listProfessions(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectPrecommunicationQuarter(quarter) {
                if (!quarter) {
                    this.loadingprecommunicationresults = true
                }
                this.selectedPrecommunicationQuarter = quarter
                this.listPrecommunication(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectPrecommunicationYear(year) {
                if (!year) {
                    this.loadingprecommunicationresults = true
                }
                this.selectedPrecommunicationYear = year
                this.listPrecommunication(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectSakaniProductsQuarter(quarter) {
                if (!quarter) {
                    this.loadingsakaniproducts = true
                }
                this.selectedSakaniProductsQuarter = quarter
                this.listSakaniProducts(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectSakaniProductsYear(year) {
                if (!year) {
                    this.loadingsakaniproducts = true
                }
                this.selectedSakaniProductsYear = year
                this.listSakaniProducts(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectSatisfactionPerQuestionQuarter(quarter) {
                if (!quarter) {
                    this.loadingsatisfactionTablePerQuestions = true
                }
                this.selectedSatisfactionPerQuestionQuarter = quarter
                this.listSakaniSatisfactionPerQuestion(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectSatisfactionPerQuestionYear(year) {
                if (!year) {
                    this.loadingsatisfactionTablePerQuestions = true
                }
                this.selectedSatisfactionPerQuestionYear = year
                this.listSakaniSatisfactionPerQuestion(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectSatisfactionPerQuestionQuarter2(quarter) {
                if (!quarter) {
                    this.loadingsatisfactionTablePerQuestions2 = true
                }
                this.selectedSatisfactionPerQuestionQuarter = quarter
                this.listSakaniSatisfactionPerQuestion2(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectSatisfactionPerQuestionYear2(year) {
                if (!year) {
                    this.loadingsatisfactionTablePerQuestions2 = true
                }
                this.selectedSatisfactionPerQuestionYear = year
                this.listSakaniSatisfactionPerQuestion2(this.selectedSurveys, this.selectedMunicipalityItems)
            },
            selectYear(year) {
                this.selectedYear = year
                this.yearMenu = false
                this.yearPicker = null
            },
            /*getAveragePercentage(municipalityGroup) {
      const totalPercentage = municipalityGroup.reduce((sum, item) => sum + item.percentage, 0)
      return (totalPercentage / municipalityGroup.length).toFixed(2) // Calculate average percentage
    },*/

            computedRating(percentage) {
                return (percentage / 100) * this.maxStars
            },

            removeItem(id) {
                const index = this.selectedMunicipalityItems.indexOf(id)
                if (index !== -1) {
                    this.selectedMunicipalityItems.splice(index, 1)
                }
            },

            selectAllItems() {
                this.selectedMunicipalityItems = this.municipalityItems.map(item => item.id)
            },

            clear() {
                this.selectedMunicipalityItems = []
                this.selectedSurveys = 0
                this.selectedYear = null
                this.selectedQuarter = null
                this.selectedIcon= null
            },

            getBackgroundColor(value) {
                const opacity = this.getOpacity(value)
                return `rgba(153,192,114, ${opacity})`
            },
            getBackgroundColorIntishar(value) {
                const opacity = this.getOpacity(value)
                return `rgba(255,150,125, ${opacity})`
            },
            getTextColor(value) {
                return value > 50 ? '#fff' : '#000'
            },
            getOpacity(value) {
                return (value / 100).toFixed(2)
            },

            listMunicipalities() {
                StructuresService.listMunicipalities().then((res) => {
                    if (res.data) {
                        this.municipalityItems = res.data.map(item => ({
                            id: item.municipalityID,
                            name: item.name
                        }))
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            async listQuestionIcons() {
                var result = await SurveyService.listQuestionIcons()
                this.icons = result.data
            },
            listSurveys() {
                SurveyService.listSurveys(true, AnalyticsTypes.Sakani).then((res) => {
                    if (res.data) {
                        this.surveys = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            async listFilterQuestions() {
                let selectedSurveys = this.selectedSurveys
                var resp = await SurveyService.listFilterQuestions(AnalyticsTypes.Sakani, selectedSurveys)
                this.filterquestions = resp.data
            },
            async listSurveyMainAnalytics(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSurveyMainAnalytics(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions)
                this.result = resp.data
                this.amanatData = []
                for (var i = 0; i < resp.data.length; i++) {
                    var x = resp.data[i]
                    this.amanatData.push({ value: x.count, label: x.municipalityName, percentage: x.percentage, logo: x.logo })
                }
                this.loading = false
            },
            async listSurveyAnalyticsPerRegion(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSurveyAnalyticsPerRegion(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions)
                this.resultregion = resp.data
                this.loadingregion = false
            },
            async listPublications(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listPublications(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.publications = resp.data.data
                question.publicationstitle = resp.data.questionName
                this.loadingpublications = false
            },
            async listCommunicationReasons(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listCommunicationReasons(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.comreasons = resp.data.data
                question.comreasonstitle = resp.data.questionName
                this.loadingcomreasons = false
            },
            async listGenders(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listGenders(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.genders = resp.data.results
                question.gendertitle = resp.data.questionName
                this.loadinggenders = false
            },
            async listNPSResults(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listNPSResults(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.npsresults = resp.data.data
                question.npsscale = resp.data.scale
                this.loadingnpsresults = false
                question.npstitle = resp.data.questionName
            },
            async listSignedQuestionAnswers(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listSignedQuestionAnswers(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.signedquestionanswers = resp.data.data
                question.signedquestionName = resp.data.questionName
                this.loadingsignedquestionanswers = false
            },
            async listPrecommunication(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listPrecommunication(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.precommunicationresults = resp.data.data
                question.precommunicationtitle = resp.data.questionName
                this.loadingprecommunicationresults = false
            },
            async listReservation(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listReservation(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.reservationresults = resp.data.data
                question.reservationtitle = resp.data.questionName
                this.loadingreservationresults = false
            },
            async listProfessions(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listProfessions(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.professions = resp.data.data
                this.loadingprofessions = false
                question.professionstitle = resp.data.questionName
            },
            async listSakaniProducts(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listSakaniProducts(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.sakaniproducts = resp.data.data
                question.sakaniproductstitle = resp.data.questionName
                this.loadingsakaniproducts = false
            },
            async listEucationalLevels(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listEucationalLevels(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.educationalLevel = resp.data.data
                question.educationalLeveltitle = resp.data.questionName
                this.loadingeducationalLevel = false
            },
            async listNationalities(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listNationalities(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.nationalities = resp.data.data
                question.nationalitytitle = resp.data.questionName
                this.loadingnationalities = false
            },
            async listAgeGroup(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listAgeGroup(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.ageGroup = resp.data.data
                question.agegrouptitle = resp.data.questionName
                this.loadingageGroup = false
            },
            async listSakaniSatisfaction(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listSakaniSatisfaction(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.satisfactionLabels = []
                question.satisfactionLogos = []
                question.satisfactionData = []
                question.satisfactiontitle = resp.data.questionName
                for (var i = 0; i < resp.data.data.length; i++) {
                    var x = resp.data.data[i]
                    question.satisfactionLabels.push('')
                    question.satisfactionLogos.push(x.logo)
                    question.satisfactionData.push(x.percentage)
                }
                this.loadingsatisfactionData = false
            },
            async listSakaniSatisfactionfromCSAT3(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSakaniSatisfactionfromCSAT3(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions)
                this.satisfactionLabels = []
                this.satisfactionLogos = []
                this.satisfactionData = []
                this.satisfactiontitle = resp.data.questionName
                for (var i = 0; i < resp.data.data.length; i++) {
                    var x = resp.data.data[i]
                    this.satisfactionLabels.push('')
                    this.satisfactionLogos.push(x.logo)
                    this.satisfactionData.push(x.percentage)
                }
                this.loadingsatisfactionData = false
            },
            async listSakaniSatisfactionPerQuestion(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSakaniSatisfactionPerQuestion(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions)
                this.satisfactionTablePerQuestions = resp.data
                this.loadingsatisfactionTablePerQuestions = false
            },
            async listSakaniSatisfactionPerQuestion3(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSakaniSatisfactionPerQuestion3(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions)
                this.satisfactionTablePerQuestions3 = resp.data
                this.loadingsatisfactionTablePerQuestions3 = false
            }, 
            async listAwarenessPerQuestion(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listAwarenessPerQuestion(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions)
                this.awarenessTablePerQuestions = resp.data
                this.loadingawarenessTablePerQuestions = false
            },
            async listRegionsPerQuestion(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listRegionsPerQuestion(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.regionsTablePerQuestions = resp.data.data.filter(x => !x.name.includes('أمانة'))
                question.amanatTablePerQuestions = resp.data.data.filter(x => x.name.includes('أمانة'))
                this.loadingregionsTablePerQuestions = false
            },
            async listSakaniSatisfactionPerQuestion2(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSakaniSatisfactionPerQuestion2(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions)
                this.satisfactionTablePerQuestions2 = resp.data
                this.loadingsatisfactionTablePerQuestions2 = false
            },
            async listSakaniSatisfactionAllRecordsAsync(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listSakaniSatisfactionAllRecordsAsync(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.satisfactionTable = resp.data.data
                question.satisfactionTableTitle = resp.data.questionName
                this.loadingsatisfactionAllRecords = false
            },
            async listCSAT52(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listCSAT52(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.csatfivetwoTable = resp.data.data
                question.csatfivetwoTableTitle = resp.data.questionName
                this.loadingcsatfivetwoTable = false
            },
            async listSakaniTripleSatisfaction(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listSakaniTripleSatisfaction(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.tripleSatisfactionTable = resp.data.data
                question.tripleSatisfactionTableTitle = resp.data.questionName
                this.loadingtripleSatisfactionTable = false
            },
            async listEndorsmentResults(selectedSurveys, selectedMunicipalities, question) {
                var resp = await SurveyService.listEndorsmentResults(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions, question.id)
                question.endorsmentResults = resp.data.data
                question.endorsmentTitle = resp.data.questionName
                this.loadingendorsmentResults = false
            },
            async listSakaniSatisfactionQuarters(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSakaniSatisfactionQuarters(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Sakani, this.filterquestions)
                this.satisfactionQuartersLabels = []
                this.satisfactionQuartersPercentages = []
                this.availableYears = []
                var rows = resp.data
                rows.sort((a, b) => a.year - b.year)
                for (var i = 0; i < rows.length; i++) {
                    var x = rows[i]
                    var qlabel = this.quarters[x.quarter - 1].text + ' ' + x.year
                    this.satisfactionQuartersLabels.push(qlabel)
                    this.satisfactionQuartersPercentages.push(x.percentage)
                    this.availableYears.push(x.year)
                }
                this.loadingsatisfactionQuarters = false
            },

            async listAnalyticsQuestions(selectedSurveys) {
                var result = await SurveyService.listAnalyticsQuestions(selectedSurveys, AnalyticsTypes.Sakani, this.selectedIcon)
                this.questions = await result.data
            },
            selectMunicipality(municipality) {
                var found = this.municipalityItems.filter(x => x.name == municipality.label)
                if (found.length > 0) {
                    var item = found[0]
                    this.selectedMunicipalityItems = []
                    this.selectedMunicipalityItems.push(item.id)
                    this.loadDemographics()
                }
            },
            async loadDemographics() {
                if (this.selectedSurveys) {
                    try {
                        let selectedSurveys = this.selectedSurveys
                        let selectedMunicipalities = this.selectedMunicipalityItems
                        this.loading = true
                        this.loadinggenders = true
                        this.loadingsignedquestionanswers = true
                        this.loadingprofessions = true
                        this.loadingeducationalLevel = true
                        this.loadingnationalities = true
                        this.loadingageGroup = true
                        this.loadingpublications = true
                        this.loadingsatisfactionData = true
                        this.loadingsatisfactionAllRecords = true
                        this.loadingsatisfactionQuarters = true
                        this.loadingregion = true
                        this.loadingprecommunicationresults = true
                        this.loadingreservationresults = true
                        this.loadingsatisfactionTablePerQuestions = true
                        this.loadingsatisfactionTablePerQuestions2 = true
                        this.loadingsatisfactionTablePerQuestions3 = true
                        this.loadingawarenessTablePerQuestions = true
                        this.loadingregionsTablePerQuestions = true
                        this.loadingtripleSatisfactionTable = true
                        this.loadingsakaniproducts = true
                        this.loadingnpsresults = true
                        this.loadingendorsmentResults = true
                        this.loadingcsatfivetwoTable = true
                        await this.listAnalyticsQuestions(selectedSurveys)
                        this.filteredQuestions.map((q) => {

                            switch (q.resultTypeId) {
                                
                                case ResultTypes.TripleSatisfaction:
                                    q.loadingtripleSatisfactionTable = true
                                    this.listSakaniTripleSatisfaction(selectedSurveys, selectedMunicipalities, q)
                                    break
                                case ResultTypes.Endorsment:
                                    this.listEndorsmentResults(selectedSurveys, selectedMunicipalities, q)
                                    break
                                    case ResultTypes.Regions:                                        
                                    this.listRegionsPerQuestion(selectedSurveys, selectedMunicipalities, q)
                                    break
                                case ResultTypes.PreCommunication:
                                    this.listPrecommunication(selectedSurveys, selectedMunicipalities, q)
                                    break
                                case ResultTypes.Reservation:
                                    this.listReservation(selectedSurveys, selectedMunicipalities, q)
                                    break
                                case ResultTypes.SignedQuestion:
                                    this.listSignedQuestionAnswers(selectedSurveys, selectedMunicipalities, q)
                                    break
                                case ResultTypes.CommunicationReason:
                                    this.listCommunicationReasons(selectedSurveys, selectedMunicipalities, q)
                                    break
                                case ResultTypes.Filter:
                                    this.listSakaniProducts(selectedSurveys, selectedMunicipalities, q)
                                    break
                                case ResultTypes.CSAT51:
                                    q.loadingsatisfactionAllRecords = true
                                    this.listSakaniSatisfactionAllRecordsAsync(selectedSurveys, selectedMunicipalities, q)
                                    break
                                case ResultTypes.CSAT5Amanat:
                                    q.loadingcsatfivetwoTable = true
                                    q.loadingsatisfactionData = true
                                    this.listCSAT52(selectedSurveys, selectedMunicipalities, q)
                                    this.listSakaniSatisfaction(selectedSurveys, selectedMunicipalities, q)
                                    break
                                case ResultTypes.Publication:
                                    q.loadingpublications = true
                                    this.listPublications(selectedSurveys, selectedMunicipalities, q)
                                    break
                                case ResultTypes.NPS:
                                    q.loadingnpsresults = true
                                    this.listNPSResults(selectedSurveys, selectedMunicipalities, q)
                                    break
                            }
                        })
                        this.filteredDemographicsQuestions.map((q) => {

                            switch (q.resultTypeId) {
                                case ResultTypes.EducationalLevel:
                                    q.loadingeducationalLevel = true
                                    this.listEucationalLevels(selectedSurveys, selectedMunicipalities, q)
                                    break
                                case ResultTypes.AgeGroup:
                                    this.listAgeGroup(selectedSurveys, selectedMunicipalities, q)
                                    break
                                case ResultTypes.Gender:
                                    q.loadinggenders = true
                                    this.listGenders(selectedSurveys, selectedMunicipalities, q)
                                    break

                                case ResultTypes.Profession:
                                    this.listProfessions(selectedSurveys, selectedMunicipalities, q)

                                    break
                                case ResultTypes.Nationality:
                                    q.loadingnationalities = true
                                    this.listNationalities(selectedSurveys, selectedMunicipalities, q)
                                    break
                            }
                        })
                        this.listSurveyMainAnalytics(selectedSurveys, selectedMunicipalities)
                        //this.listSurveyAnalyticsPerRegion(selectedSurveys, selectedMunicipalities)
                        this.listSakaniSatisfactionQuarters(selectedSurveys, selectedMunicipalities)
                        this.listSakaniSatisfactionPerQuestion(selectedSurveys, selectedMunicipalities)
                        this.listAwarenessPerQuestion(selectedSurveys, selectedMunicipalities)
                        this.listSakaniSatisfactionPerQuestion2(selectedSurveys, selectedMunicipalities)
                        this.listSakaniSatisfactionPerQuestion3(selectedSurveys, selectedMunicipalities)
                        this.listSakaniSatisfactionfromCSAT3(selectedSurveys, selectedMunicipalities)
                    }
                    catch (ex) {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        this.loading = false
                        this.loadinggenders = false
                        this.loadingsignedquestionanswers = true
                        this.loadingprofessions = false
                        this.loadingeducationalLevel = false
                        this.loadingnationalities = false
                        this.loadingageGroup = false
                        this.loadingpublications = false
                        this.loadingsatisfactionData = false
                        this.loadingsatisfactionAllRecords = false
                        this.loadingsatisfactionQuarters = false
                        this.loadingregion = false
                        this.loadingprecommunicationresults = false
                        this.loadingreservationresults = false
                        this.loadingsatisfactionTablePerQuestions = false
                        this.loadingsatisfactionTablePerQuestions2 = false
                        this.loadingsatisfactionTablePerQuestions3 = false
                        this.loadingawarenessTablePerQuestions = false
                        this.loadingregionsTablePerQuestions = false
                        this.loadingtripleSatisfactionTable = false
                        this.loadingsakaniproducts = false
                        this.loadingnpsresults = false
                        this.loadingendorsmentResults = false
                        this.loadingcsatfivetwoTable = false
                    }
                }
                else {
                    this.$root.$notification(this.$t('PleaseChooseSurvey'), 'error')
                }
            },
        },
    }
</script>

<style scoped>
    .ksa-bg {
        background: url(../assets/images/KSA.png) no-repeat center
    }

    .pink-color {
        color: #ff99cc !important
    }

    .amber-color {
        color: #bf9000 !important
    }

    .green-color {
        color: #6ba786 !important
    }

    .chart-title {
        display: flex;
        align-items: center; /* Align icon and text vertically */
    }

        .chart-title .icon {
            display: flex;
            align-items: center;
        }

    [dir="rtl"] .chart-title .icon {
        margin-right: 0;
        margin-left: 0.5em;
    }
    
</style>